import { Injectable, inject } from "@angular/core";
import { Observable, shareReplay} from "rxjs";
import { AppSettingsService } from "../core";
import { HttpClient } from "@angular/common/http";
import { IDynamicControlModel } from "./dynamic-control-model";
import { IUserInfoResponse } from "../features/requester-access/models/get-user-info-response.model";

@Injectable()
export class MasterDataService{

    private appSettings = inject(AppSettingsService);
    private http = inject(HttpClient);
    private readonly baseUrl = `${this.appSettings.baseApiUrl}/api/MasterData`;
    
    public GetMasterData():Observable<Partial<IDynamicControlModel[]>>{
        return this.http.get<Partial<IDynamicControlModel[]>>(`${this.baseUrl}/get-master-tags`)
               .pipe(shareReplay());
    }

  public GetUserInfo(userName: string){
    return this.http.get<IUserInfoResponse[]>(
      `${this.baseUrl}/get-user-info?userName=${userName}`);
  }

}